<template>
    <div>
      <el-upload
          v-if="typeItem == 'upload' && scopeData.title == '附件'"
          class="upload-demo"
          ref="upload"
          :limit="1"
          :action="scopeData.props.action"
          :headers="scopeData.props.headers"
          :on-success="handleSuccess"
          :data="scopeData.props.data"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :disabled="fileListFj != undefined ? true : false"
          :file-list="fileListFj"
      >
        <el-button slot="trigger" size="small"><i class="el-icon-upload" style="font-size: 15px;"></i>&nbsp;上传文件</el-button>
        <div slot="tip" class="el-upload__tip">支持扩展名：.rar .zip .doc .docx .pdf .jpeg ...</div>
      </el-upload>
      <el-upload
        ref="uploadRef"
        v-if="typeItem == 'upload' && scopeData.title != '附件'"
        :action="scopeData.props.action"
        list-type="picture-card"
        :limit="scopeData.props.limit"
        :headers="scopeData.props.headers"
        :on-success="handleSuccess"
        :data="scopeData.props.data"
        :class="listType == 1 ? 'hide_box hlh' : ' hlh'"
        :disabled="fileListUf != undefined ? true : false"
        :file-list="fileListUf"
        multiple
      >
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" >
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
            >
              <i class="el-icon-zoom-in"></i>
            </span>
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleDownload(file)"
            >
              <i class="el-icon-download"></i>
            </span>
            <span
              v-if="!disabled && listType != 1"
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>

      <el-select v-if="typeItem == 'select'" :disabled="listType == 1 ? true : false" v-model="scopeData.props.field" @change="changeSelect" filterable placeholder="请选择">
        <el-option
          v-for="item in scopeData.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          >
        </el-option>
      </el-select>
    </div>
</template>

<script>
    export default {
      props: ['scope', 'typeItem', 'formData', 'fileListFj', 'fileListUf'],
      data () {
        return {
          listType: 0,
          scopeData: this.scope,
          dialogImageUrl: '',
          dialogVisible: false,
          disabled: false,
          fileList: [],
          field: ''
        }
      },
      created() {
        console.log(this.scope)
        console.log(this.fileListFj)
        if (this.scope.field == 'replay') {
          this.scope.value = "1"
          this.scopeData.props.field = "1"
        }
      },
      methods: {
        handlePreview() {

        },
        changeSelect(val) {
          console.log(val)
          let sub = this.formData
          console.log(this.scopeData.field)
          sub.form[this.scopeData.field] = val
          console.log(sub)
          this.$emit('update:formData', sub)
        },
        handleRemove(file) {
          console.log(file);
          console.log(this.$refs.uploadRef)
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        handleDownload(file) {
          console.log(file);
          window.open(file.url)
        },
        handleSuccess(res, file, fileList) {
          console.log('ces11')
          console.log(file)
          file.url = res.data.url
          file.name = file.raw.name
          console.log(this.fileList)
          if (this.fileList[res.data.fieldName]) {
            this.fileList[res.data.fieldName].push({url: file.url, name: file.name})
          } else {
            this.fileList[res.data.fieldName] = []
            this.fileList[res.data.fieldName].push({url: file.url, name: file.name})
            console.log(this.fileList)
          }
          let sub = this.formData
          console.log(this.scopeData.field)
          sub.form[this.scopeData.field] = this.fileList[res.data.fieldName]
          console.log(sub)
          this.$emit('update:formData', sub)
          if (this.scopeData.field != 'upload_file') {
            this.listType = 1
          }
        }
      }
    }
</script>

<style scoped>
.hide_box >>> .el-upload--picture-card{
  display: none;
}
.hlh >>> ul{
   padding-left: 0px !important;
}
</style>
